import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickerCardComponent } from '../ticker-card/ticker-card.component';

@Component({
  selector: 'dk-leads-ticker',
  templateUrl: 'leads-ticker.component.html',
  standalone: true,
  imports: [CommonModule, TickerCardComponent],
})
export class LeadsTickerComponent {}
